import { Component, OnInit, Input, Output, EventEmitter } from "@angular/core";

@Component({
    selector: "app-btn",
    templateUrl: "./btn.component.html",
    styleUrls: ["./btn.component.scss"],
    standalone: false
})
export class BtnComponent {
  @Input() dataTxt: string;
  @Input() disabled = false;
  @Input() color = "primary";
  @Input() classes: string;
  @Input() icon: string;
  @Input() iconLocation = "left";
  @Output() callback: EventEmitter<any> = new EventEmitter();

  constructor() {}

  onClick() {
    this.callback.emit();
  }
}